import { render, staticRenderFns } from "./SVGDialog.vue?vue&type=template&id=6202a982&scoped=true&"
import script from "./SVGDialog.vue?vue&type=script&lang=js&"
export * from "./SVGDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6202a982",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6202a982')) {
      api.createRecord('6202a982', component.options)
    } else {
      api.reload('6202a982', component.options)
    }
    module.hot.accept("./SVGDialog.vue?vue&type=template&id=6202a982&scoped=true&", function () {
      api.rerender('6202a982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGDialog.vue"
export default component.exports